<template>
	<v-container class="py-0 mb-4">
		<v-card elevation="0" class="ant-card px-4 pt-2 pb-4">
			<v-toolbar flat dense class="pl-0">
				<div class="v-typography--title1">
					{{ $t("products") }}
				</div>
			</v-toolbar>

			<v-divider class="mb-6 mt-1" />

			<common-table
				:headers="productListHeaders"
				:items="mergedProducts"
				:hide-pagination="true"
				:entity-name="$t('products')"
			>
				<template #item.name="{ item }">
					<span class="primary--text underlined" @click="showProductContainers(item)">
						{{ item.name }}
					</span>
				</template>

				<template #item.price="{ item }">
					{{ formatCurrency(item.amount) }}
				</template>

				<template #item.quantity="{ item }"> {{ item.quantity }} {{ item.unitCode }} </template>

				<template #item.total_amount="{ item }">
					<div class="d-flex justify-end">
						{{ formatCurrency(item.amount * item.quantity) }}
					</div>
				</template>
			</common-table>
			<v-divider class="my-4" />

			<div v-if="mergedProducts.length > 0" class="mt-4">
				<v-row v-if="totalSum != 0" align="center" class="px-4 pb-1" justify="space-between">
					<v-col cols="auto" class="d-flex align-center">
						<v-icon color="black" class="mr-2">icon-money</v-icon>
						<span class="v-typography--body1">{{ $t("total_amount") }}</span>
					</v-col>
					<v-col cols="auto" class="text-right">
						<span class="text-lg font-weight-bold">
							{{ formatCurrency(totalSum) }}
						</span>
					</v-col>
				</v-row>
			</div>
		</v-card>

		<product-containers-dialog
			v-model="productContainersDialog.visible"
			:product="productContainersDialog.product"
			:shipment="shipment"
			@select-container="emitShowContainer"
		/>
	</v-container>
</template>

<script>
import CommonTable from "../../../partials/CommonTable.vue";
import ProductContainersDialog from "../dialog/ProductContainersDialog.vue";

export default {
	name: "Products",
	components: {
		CommonTable,
		ProductContainersDialog,
	},
	props: {
		shipment: {
			type: Object,
			required: true,
		},
	},
	watch: {
		mergedProducts: {
			immediate: true,
			handler(v) {
				this.$emit("merged-products-updated", v);
			},
		},
	},
	data() {
		return {
			productListHeaders: [
				{ text: this.$t("name"), value: "name", sortable: false },
				{ text: this.$t("amount"), value: "price", sortable: false },
				{ text: this.$t("quantity"), value: "quantity", sortable: false },
				{ text: this.$t("total_amount"), value: "total_amount", sortable: false },
			],
			productContainersDialog: { visible: false, product: null },
		};
	},
	computed: {
		mergedProducts() {
			if (!this.shipment?.containers?.length) return [];
			const map = new Map();
			const getName = (p) => {
				const fromLocale = p.name?.[this.$i18n.locale];
				const anyName = Object.values(p.name || {}).find((v) => v);
				return fromLocale ?? p.name?._default ?? p.displayName ?? anyName ?? "Unnamed";
			};
			for (const c of this.shipment.containers) {
				for (const p of c.products || []) {
					const name = getName(p);
					const k = `${name}-${p.amount}-${p.unitCode}`;
					if (!map.has(k)) map.set(k, { name, amount: p.amount, quantity: p.quantity, unitCode: p.unitCode });
					else map.get(k).quantity += p.quantity;
				}
			}
			return [...map.values()];
		},
		totalSum() {
			return this.mergedProducts.reduce((s, p) => s + p.amount * p.quantity, 0);
		},
	},
	methods: {
		formatCurrency(v) {
			if (!this.shipment?.currency) return v;
			return v.toLocaleString(this.$lang, { style: "currency", currency: this.shipment.currency.code });
		},
		showProductContainers(p) {
			this.productContainersDialog.product = p;
			this.productContainersDialog.visible = true;
		},
		emitShowContainer(c) {
			this.$emit("show-container", c);
		},
	},
};
</script>

<style scoped>
.primary--text.underlined {
	cursor: pointer;
	text-decoration: underline;
}
</style>
